import React from 'react'
import './../styles/Loader.css'

const Loader: React.FC = () => {
  return (
    <div className='loader-wrapper'>
      <div className='loader' />
    </div>
  )
}

export default Loader
